import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import { cn } from '@module/lib/utils';
import type { PersonalAdminMessage } from '@module/types/centrifuge/personalMessageTypes';
import AdminChat from './AdminChat';
interface Props {
  item: PersonalAdminMessage;
}
export default function PersonalAdminChat(props) {
  const $ = _c(22);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  if (message.whisper === "Y") {
    const t0 = message.name === "police";
    let t1;
    if ($[0] !== t0) {
      t1 = cn("whitespace-pre-wrap text-[#f10000]", {
        "text-[red]": t0
      });
      $[0] = t0;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <span>{"\uADD3\uC18D\uB9D0)"} </span>;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== message.name) {
      t3 = message.name === "police" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/grade/ico_live_police.png`} alt="police" className="mr-1 h-[15px] w-[15px]" crossOrigin="anonymous" />;
      $[3] = message.name;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== message.name) {
      t4 = message.name === "admin" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/grade/ico_class_a.png`} alt="admin" className="mr-1 h-[15px] w-[15px]" crossOrigin="anonymous" />;
      $[5] = message.name;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    const t5 = message.name === "admin" ? "\uC6B4\uC601\uD300" : "\uD3F4\uB9AC\uC2A4";
    let t6;
    if ($[7] !== t5) {
      t6 = <span>{t5}</span>;
      $[7] = t5;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t3 || $[10] !== t4 || $[11] !== t6) {
      t7 = <div className="flex items-center">{t2}{t3}{t4}{t6}</div>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== message.message) {
      t8 = <span className="text-left">{message.message}</span>;
      $[13] = message.message;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== t1 || $[16] !== t7 || $[17] !== t8) {
      t9 = <div className={t1}>{t7}{t8}</div>;
      $[15] = t1;
      $[16] = t7;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    return t9;
  }
  let t0;
  if ($[19] !== message.message || $[20] !== message.name) {
    t0 = <AdminChat type={message.name} message={message.message} />;
    $[19] = message.message;
    $[20] = message.name;
    $[21] = t0;
  } else {
    t0 = $[21];
  }
  return t0;
}